import { useTranslation } from 'react-i18next'

import { RENTAL_PORTAL_VIEWING_STATUS } from '../../../../../../constants/rentalPortal'
import { useRentalPortalProfileHeaderFooterMeasure } from '../../../../RentalPortalProfileHeaderFooter'
import { VIEWING_PROFILE_ACTION } from '../../../RentalPortalViewingProfile.constants'
import {
  useViewingArchiveActions,
  useViewingDocumentUpload,
  useViewingIcsDownload,
  useViewingProfileContext,
  useViewingReschedule,
  useViewingStatusChange,
} from '../../../RentalPortalViewingProfile.hooks'
import { getViewingProfileFooterActions } from '../../RentalPortalViewingProfileHeaderFooter.utils'

export function useViewingProfileHeaderFooter() {
  const { t } = useTranslation()

  const { handleStartNoteEdit, viewingData } = useViewingProfileContext()

  const { handleOpenStatusConfirmation } = useViewingStatusChange()

  const { handleOpenReschedule } = useViewingReschedule()

  const { handleOpenDocumentUpload } = useViewingDocumentUpload()

  const { handleDownloadIcs } = useViewingIcsDownload()

  const { handleClickArchive, handleClickRestore } = useViewingArchiveActions()

  function handleClickCancel() {
    handleOpenStatusConfirmation(RENTAL_PORTAL_VIEWING_STATUS.cancelled)
  }

  function handleClickCompleted() {
    handleOpenStatusConfirmation(RENTAL_PORTAL_VIEWING_STATUS.completed)
  }

  function handleClickNoShow() {
    handleOpenStatusConfirmation(RENTAL_PORTAL_VIEWING_STATUS.noShow)
  }

  const actionHandlers = {
    [VIEWING_PROFILE_ACTION.addNote]: handleStartNoteEdit,
    [VIEWING_PROFILE_ACTION.addToCalendar]: handleDownloadIcs,
    [VIEWING_PROFILE_ACTION.archive]: handleClickArchive,
    [VIEWING_PROFILE_ACTION.cancel]: handleClickCancel,
    [VIEWING_PROFILE_ACTION.completed]: handleClickCompleted,
    [VIEWING_PROFILE_ACTION.noShow]: handleClickNoShow,
    [VIEWING_PROFILE_ACTION.reschedule]: handleOpenReschedule,
    [VIEWING_PROFILE_ACTION.restore]: handleClickRestore,
    [VIEWING_PROFILE_ACTION.uploadDocument]: handleOpenDocumentUpload,
  }

  const actions = getViewingProfileFooterActions({ t, viewingData })

  const measure = useRentalPortalProfileHeaderFooterMeasure({ actions })

  function handleSelectMoreOption({ disabled, value }) {
    return disabled ? null : actionHandlers[value]?.()
  }

  return {
    ...measure,
    actionHandlers,
    handleSelectMoreOption,
    hasActions: actions.length > 0,
  }
}
